import type { GameState, PlayerAction } from '@/types';
import { EasyAI } from './easy-ai';
import { MediumAI } from './medium-ai';
import { HardAI } from './hard-ai';

// AI 实例缓存
const aiInstances: Map<string, EasyAI | MediumAI | HardAI> = new Map();

export function getAI(level: 'easy' | 'medium' | 'hard'): EasyAI | MediumAI | HardAI {
  const key = level;
  
  if (!aiInstances.has(key)) {
    switch (level) {
      case 'easy':
        aiInstances.set(key, new EasyAI());
        break;
      case 'medium':
        aiInstances.set(key, new MediumAI());
        break;
      case 'hard':
        aiInstances.set(key, new HardAI());
        break;
    }
  }
  
  return aiInstances.get(key)!;
}

export function makeAIDecision(
  state: GameState, 
  playerId: string, 
  level: 'easy' | 'medium' | 'hard'
): PlayerAction {
  const ai = getAI(level);
  return ai.decide(state, playerId);
}

export function recordHumanAction(
  _state: GameState,
  humanId: string,
  action: PlayerAction,
  phase: string
): void {
  // 更新所有高级 AI 的对手模型
  for (const [, ai] of aiInstances) {
    if (ai instanceof HardAI) {
      ai.recordOpponentAction(humanId, action, phase);
    }
  }
}

export { EasyAI, MediumAI, HardAI };
